<div class="sx-tips">
    <div class="sx-tips-header">
        <button class="sx-button sx-button--white sx-button--exit" mat-button (click)="onClose()">
            <svg>
              <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
            </svg>
        </button>
        <span>{{ 'core.header.tips.title' | translate }}</span>
    </div>
    <div class="sx-tips-filter">
        <div class="sx-tips-filter-control">
            <mat-slide-toggle id="tip_only_unread" (change)="onUnreadChange($event)" [(ngModel)]="isUnreadOnly"><span>{{ 'core.header.tips.only-unread-toggle' | translate }}</span></mat-slide-toggle>
        </div>
    </div>
    <div class="sx-tips-item-container">
        <div class="sx-tips-items">
            <ng-container *ngFor="let tip of filteredTips">
                <app-tip-item [tip]="tip" (navigate)="onNavigate($event)" (hide)="onHide($event)"></app-tip-item>
            </ng-container>
        </div>
        <app-system-message 
            [isVisible]="filteredTips.length === 0" 
            [isDismissable]="false" 
            [severity]="1" 
            [icon]="'#sx-info'"
            [type]="3">
            <span style="white-space: nowrap;">{{ 'core.header.tips.no-tips' | translate }}</span>
        </app-system-message>
    </div>
</div>